import React from "react";

export const DetailArticle = () => {
  return <div className="details__profile"></div>;
};
